import { useEffect, useState } from 'react';

import { ownerApi } from '../api/owner';
import type { OwnerFeedbackItem, OwnerLeadItem } from '../types';

function Stars({ rating }: { rating: number }) {
  return (
    <span aria-label={`${rating} out of 5`} className="text-amber-500">
      {'★'.repeat(rating)}
      <span className="text-slate-300">{'★'.repeat(5 - rating)}</span>
    </span>
  );
}

export function Insights() {
  const [feedback, setFeedback] = useState<OwnerFeedbackItem[]>([]);
  const [leads, setLeads] = useState<OwnerLeadItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const [f, l] = await Promise.all([ownerApi.getFeedback(1), ownerApi.getLeads(1)]);
      setFeedback(f.data);
      setLeads(l.data);
      setLoading(false);
    })();
  }, []);

  if (loading) return <p className="text-sm text-slate-500">Loading…</p>;

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-xl font-semibold text-slate-900">Insights</h1>
        <p className="text-sm text-slate-500">Read-only view of customer feedback and leads.</p>
      </div>

      <section>
        <h2 className="mb-3 text-sm font-semibold uppercase tracking-wide text-slate-500">Recent feedback</h2>
        <div className="rounded-brand border border-slate-200 bg-white">
          <ul className="divide-y divide-slate-100">
            {feedback.map((f) => (
              <li key={f.id} className="p-4">
                <div className="flex items-center justify-between">
                  <Stars rating={f.rating} />
                  <span className="text-xs text-slate-400">{new Date(f.created_at).toLocaleDateString('en-IN')}</span>
                </div>
                {f.improvement_text && <p className="mt-1 text-sm text-slate-600">{f.improvement_text}</p>}
              </li>
            ))}
            {!feedback.length && <li className="p-4 text-sm text-slate-500">Abhi koi feedback nahi hai.</li>}
          </ul>
        </div>
      </section>

      <section>
        <h2 className="mb-3 text-sm font-semibold uppercase tracking-wide text-slate-500">Recent leads</h2>
        <div className="rounded-brand border border-slate-200 bg-white">
          <ul className="divide-y divide-slate-100">
            {leads.map((l) => (
              <li key={l.id} className="flex items-center justify-between p-4">
                <div>
                  <p className="font-medium text-slate-900">{l.name}</p>
                  <p className="text-sm text-slate-500">{l.phone}</p>
                </div>
                <span className="rounded-brand bg-slate-100 px-2 py-1 text-xs font-medium text-slate-600">
                  {l.status}
                </span>
              </li>
            ))}
            {!leads.length && <li className="p-4 text-sm text-slate-500">Abhi koi leads nahi hai.</li>}
          </ul>
        </div>
      </section>
    </div>
  );
}
